import React from "react";
import { GuestNameWithFlag } from "@/components/pages/reservations/guests/components/GuestNameWithFlag";

interface NameCellProps {
  name: string;
  countryCode: string;
}

export const NameCell: React.FC<NameCellProps> = ({ name, countryCode }) => {
  return <GuestNameWithFlag name={name} countryCode={countryCode} />;
};
